module.exports = __webpack_public_path__ + "img/57_1.014c7beb.png";